
    import './styles.scoped.css';
    export default {
  "label": "awsui_label_aqu00_ocied_5"
};
  